module.exports = __webpack_public_path__ + "assets/img/c0d3-pe.svg";